import useFunctionContext from '/druid/internal/useFunctionContext';

export default function useScrollOneLeft() {
  const { scrollOneLeft } = useFunctionContext();

  return scrollOneLeft;
}
